export const INDEX = "/";
export const ABOUT = "/about";
export const SUBNETCALC = "/subnet-calculator";
export const ASLOOKUP = "/as-lookup";
